import { Controller } from '@hotwired/stimulus';

// Shows the fields target and enables its inputs only while the checkbox target is checked
export default class extends Controller {
    static targets = ['checkbox', 'fields'];

    connect() {
        this.sync();
    }

    sync() {
        const isChecked = this.checkboxTarget.checked;

        this.fieldsTarget.hidden = !isChecked;
        this.fieldsTarget.querySelectorAll('input').forEach((input) => {
            input.disabled = !isChecked;
            input.required = isChecked;
        });
    }
}
